import {
    FetchState,
    HsabAccountNametag,
    HsabAccountType
} from "@/shared/types";

import { defineStore } from "pinia";
import _ from "lodash";
import { getHsabAccountTypes as bankServiceGetHsabAccountTypes, getHsabAccountTypesAdmin } from "@/shared/api/bankService";
import { handleError as storeHelperHandleError } from "@/shared/storeHelper";
import { HsabAccountState } from "@/employer/types";
import { useUserStore } from "@/shared/store/user";

export const initialState: HsabAccountState = {
    fetchState: FetchState.Uninitialized,
    account: null,
    username: ""
};

export const useHsaAccountStore = defineStore("hsaAccounts", {
    state: () => (_.cloneDeep(initialState)),
    actions: {
        setHsaAccount (data: HsabAccountNametag) {
            this.account = data;
            this.fetchState = FetchState.Loaded;
        },
        getHsaAccount (args: { username: string, partnerId: number}): Promise<any> {
            if (this.username === args.username) {
                return;
            }

            this.username = args.username;
            this.fetchState = FetchState.Loading;

            return fetchHsabAccounts(args)
            .then(response => {
                const foundAccount = response.data.accounts.find(item => item.bankAccountType === HsabAccountType.Hsa);
                this.setHsaAccount(foundAccount);
            })
            .catch(err => {
                this.fetchState = FetchState.Failed;
                return storeHelperHandleError({ error: err, rethrow: true });
            });
        }
    }
});

function fetchHsabAccounts (args: { username: string, partnerId: number}) {
    const userStore = useUserStore();
    return userStore.isAdminPortal
        ? getHsabAccountTypesAdmin(args)
        : bankServiceGetHsabAccountTypes(args);
}